import { useState } from "react";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { getWhatsAppUrl } from "@/utils/whatsapp";

export const EnquiryForm = () => {
  const [draftUrl, setDraftUrl] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const details = Object.fromEntries(
      [...new FormData(form)].map(([key, value]) => [key, value.trim()])
    );
    for (const name of ["name", "location", "product", "contact"]) {
      if (!details[name]) {
        const field = form.elements.namedItem(name);
        field.setCustomValidity("Please complete this field.");
        field.reportValidity();
        return;
      }
    }
    const contact = details.contact;
    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(contact);
    const phone = contact.replace(/[\s().-]/g, "");
    const validPhone = /^\+?\d{7,15}$/.test(phone);
    if (!validEmail && !validPhone) {
      const field = form.elements.namedItem("contact");
      field.setCustomValidity("Enter a valid email address or a phone number with 7–15 digits.");
      field.reportValidity();
      return;
    }
    const message = [
      "Hello ASCSI, I would like to make a wholesale or export enquiry.",
      "",
      `Name: ${details.name}`,
      `Company: ${details.company || "Not provided"}`,
      `Country / City: ${details.location}`,
      `Product: ${details.product}`,
      `Quantity: ${details.quantity || "Not provided"}`,
      `Phone / Email: ${details.contact}`,
      `Message: ${details.message || "Not provided"}`,
    ].join("\n");
    const url = getWhatsAppUrl(message);
    setDraftUrl(url);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <form className="enquiry-form" onSubmit={handleSubmit} onInput={(event) => event.target.setCustomValidity?.("")} data-testid="enquiry-form">
      {draftUrl ? (
        <div className="form-success" role="status" data-testid="form-success">
          <span>✓</span>
          <h3>Your enquiry is ready.</h3>
          <p>Continue on WhatsApp and press Send to submit your enquiry.</p>
          <a className="button button-dark" href={draftUrl} target="_blank" rel="noopener noreferrer" data-testid="success-whatsapp-link"><MessageCircle size={17} /> Continue on WhatsApp</a>
        </div>
      ) : (
        <>
          <div className="form-row"><label>Name<input required name="name" placeholder="Your name" data-testid="enquiry-name-input" /></label><label>Company<input name="company" placeholder="Company name" data-testid="enquiry-company-input" /></label></div>
          <div className="form-row"><label>Country / City<input required name="location" placeholder="Where are you based?" data-testid="enquiry-location-input" /></label><label>Product<input required name="product" placeholder="What are you looking for?" data-testid="enquiry-product-input" /></label></div>
          <div className="form-row"><label>Quantity<input name="quantity" placeholder="Approximate quantity" data-testid="enquiry-quantity-input" /></label><label>Phone / Email<input required name="contact" placeholder="Best way to reach you" data-testid="enquiry-contact-input" /></label></div>
          <label>Message<textarea name="message" placeholder="Tell us a little more about your requirement" rows="4" data-testid="enquiry-message-input" /></label>
          <button className="button button-dark submit-button" type="submit" data-testid="enquiry-submit-button">Send enquiry <ArrowUpRight size={17} /></button>
        </>
      )}
    </form>
  );
};